module.exports = __webpack_public_path__ + "static/media/logos_50h_ibm.a726bdbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_ibm.jpg
// module id = 219
// module chunks = 0